import type { ColoredMaterial } from "@color-finder/color-finder-api/models";
import { Box, Stack } from "@mui/material";
import type { FC } from "react";
import { ColorSpecification } from "./ColorSpecification";

export interface ColorSpecificationsListProps {
  material: ColoredMaterial;
}

export const ColorSpecificationList: FC<ColorSpecificationsListProps> = ({
  material,
}) => {
  return (
    <Stack spacing={6}>
      {material.color.specifications?.all.map((specification) => (
        <Box key={specification.ppNr}>
          <ColorSpecification specification={specification} />
        </Box>
      ))}
    </Stack>
  );
};
